var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgChatIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C16.275 0 21 3.779 21 8.444c0 4.666-4.725 8.445-10.5 8.445-1.302 0-2.551-.19-3.707-.528C3.728 19 0 19 0 19c2.446-2.46 2.835-4.117 2.888-4.75C1.103 12.74 0 10.693 0 8.444 0 3.78 4.725 0 10.5 0Zm5.25 9.5V7.389h-2.1V9.5h2.1Zm-4.2 0V7.389h-2.1V9.5h2.1Zm-4.2 0V7.389h-2.1V9.5h2.1Z",
    fill: "#2E2E2E"
  })));
};
export { SvgChatIcon as ReactComponent };
export default __webpack_public_path__ + "d4b4d10f838db9fd1c0c00b97ad1b6b8.svg";